import React from "react";
import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { getUserAuth } from "../../recoil/selectors";
import {
  CreateAccountDesktopContainer,
  CreateAccountDesktopColorBackground,
  CreateAccountDesktopGradientLayer,
  CreateAccountDesktopBrandPanel,
  CreateAccountDesktopBrandLockup,
  CreateAccountDesktopFormCell,
  CreateAccountNonDesktopShell,
  CreateAccountHeroBand,
  CreateAccountHeroLockupImg,
  CreateAccountNonDesktopContents,
} from "../CreateAccount/CreateAccountForm.styles";
import unityLockup from "../../assets/logos/unity-rebrand/unity-vert-cobranded.svg";
import unityLockupHorizontal from "../../assets/logos/unity-rebrand/unity-horiz-cobranded.svg";
import { VerifyEmailSendAgainSection } from "./VerifyEmailSectionSendAgainSection";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { LOGIN_PAGE_URL } from "../../utils/urlConstants";
import Loading from "../shared/Loading/Loading";

export const VerifyEmailSendAgain = (): React.ReactElement => {
  const { isDesktop } = useDeviceHook();
  const history = useHistory();
  const auth = useRecoilValue(getUserAuth);

  if (!auth) {
    history.push(LOGIN_PAGE_URL);
    return <Loading />;
  }

  return (
    <div data-testid="verify-email-send-again">
      {isDesktop && (
        <CreateAccountDesktopContainer>
          <CreateAccountDesktopColorBackground>
            <CreateAccountDesktopGradientLayer aria-hidden />
            <CreateAccountDesktopBrandPanel>
              <CreateAccountDesktopBrandLockup
                src={unityLockup}
                alt="Unity by BillionToOne"
              />
            </CreateAccountDesktopBrandPanel>
          </CreateAccountDesktopColorBackground>
          <CreateAccountDesktopFormCell>
            <VerifyEmailSendAgainSection />
          </CreateAccountDesktopFormCell>
        </CreateAccountDesktopContainer>
      )}
      {!isDesktop && (
        <CreateAccountNonDesktopShell>
          <CreateAccountHeroBand>
            <CreateAccountHeroLockupImg
              src={unityLockupHorizontal}
              alt="Unity by BillionToOne"
            />
          </CreateAccountHeroBand>
          <CreateAccountNonDesktopContents>
            <VerifyEmailSendAgainSection />
          </CreateAccountNonDesktopContents>
        </CreateAccountNonDesktopShell>
      )}
    </div>
  );
};
